import { useCallback } from "react";

export type TWebsiteBuilderTreeRefMap = React.MutableRefObject<Map<string, HTMLDivElement | null>>;

export function useTreeRefMapRegistration(id: string, treeRefMap: TWebsiteBuilderTreeRefMap) {
  return useCallback(
    (el: HTMLDivElement | null) => {
      if (el) {
        treeRefMap.current.set(id, el);
      } else {
        treeRefMap.current.delete(id);
      }
    },
    [id],
  );
}
